<template>
  <div class="inline">
    <a href="#" class="link-green" @click.prevent="show">
      <slot />
    </a>
    <modal :name="name" class="relative">
        <button type="button" class="bg-red-500 hover:bg-red-600 rounded absolute right-0 top-0 mt-2 mr-2" @click="hide">
            <div class="text-white text-6xl p-3">
                <svg class="w-3 h-3 fill-current" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 348.333 348.334" style="enable-background:new 0 0 348.333 348.334;" xml:space="preserve">
<g><path d="M336.559,68.611L231.016,174.165l105.543,105.549c15.699,15.705,15.699,41.145,0,56.85
c-7.844,7.844-18.128,11.769-28.407,11.769c-10.296,0-20.581-3.919-28.419-11.769L174.167,231.003L68.609,336.563
c-7.843,7.844-18.128,11.769-28.416,11.769c-10.285,0-20.563-3.919-28.413-11.769c-15.699-15.698-15.699-41.139,0-56.85
l105.54-105.549L11.774,68.611c-15.699-15.699-15.699-41.145,0-56.844c15.696-15.687,41.127-15.687,56.829,0l105.563,105.554
L279.721,11.767c15.705-15.687,41.139-15.687,56.832,0C352.258,27.466,352.258,52.912,336.559,68.611z"/></g>
</svg>
            </div>
        </button>
      <div class="flex items-center flex-col py-8">
        <h1 class="title title-red md:text-4xl">Available Truffle Choices</h1>
          <button type="button" class="bg-red-500 hover:bg-red-600 rounded absolute right-0 top-0 mt-2 mr-2" @click="hide">
              <div class="text-white text-6xl p-3">
<svg class="w-3 h-3 fill-current" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 348.333 348.334" style="enable-background:new 0 0 348.333 348.334;" xml:space="preserve">
<g><path d="M336.559,68.611L231.016,174.165l105.543,105.549c15.699,15.705,15.699,41.145,0,56.85
c-7.844,7.844-18.128,11.769-28.407,11.769c-10.296,0-20.581-3.919-28.419-11.769L174.167,231.003L68.609,336.563
c-7.843,7.844-18.128,11.769-28.416,11.769c-10.285,0-20.563-3.919-28.413-11.769c-15.699-15.698-15.699-41.139,0-56.85
l105.54-105.549L11.774,68.611c-15.699-15.699-15.699-41.145,0-56.844c15.696-15.687,41.127-15.687,56.829,0l105.563,105.554
L279.721,11.767c15.705-15.687,41.139-15.687,56.832,0C352.258,27.466,352.258,52.912,336.559,68.611z"/></g>
</svg>
              </div>
          </button>
        <ul class="text-lg">
          <li>Milk Chocolate Amaretto</li>
          <li>Dark Chocolate Raspberry</li>
          <li>Milk Chocolate Hazelnut</li>
          <li>White Chocolate Tiramisu</li>
          <li>Milk Chocolate Caramel</li>
        </ul>

      </div>
    </modal>

  </div>
 </template>

 <script>
   export default {
       // name: 'truffles-choices',
     props: ['value'],

     computed: {
        name () {
          return `modal-${this.value}`
        }
     },

     methods: {
       show () {
         this.$modal.show(this.name);
       },
       hide () {
         this.$modal.hide(this.name);
       }
     }
   }
 </script>

<style scoped>
  table tr td {
    background: #fff!important;
  }
</style>
